/**
 * @generated SignedSource<<cac8e8637f81f5889b0dc83ba73416ed>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "DeleteSchedulePermissionPayload",
            "kind": "LinkedField",
            "name": "deleteSchedulePermission",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfSchedulePermission",
                    "kind": "LinkedField",
                    "name": "schedulePermissionEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulePermission",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SchedulePermissionListItem_deleteSchedulePermissionMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SchedulePermissionListItem_deleteSchedulePermissionMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "6e4ec4352102ab1024c8b9742e91ca68",
            "id": null,
            "metadata": {},
            "name": "SchedulePermissionListItem_deleteSchedulePermissionMutation",
            "operationKind": "mutation",
            "text": "mutation SchedulePermissionListItem_deleteSchedulePermissionMutation(\n  $model: DeleteSchedulePermissionInput!\n) {\n  deleteSchedulePermission(model: $model) {\n    schedulePermissionEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "2e2feb1938e60fa17eb82395667e9885";
export default node;
